<template>
  <div class="parking99-phase-five">
    <el-row :gutter="20">
      <el-col v-if="showParkingCommunityColumn" :span="4">
        <select-admin-community
          :allow-all="false"
          :community-options="parkingCommunities"
          @changeCommunity="handleChangeCommunity" />
      </el-col>
      <el-col :span="showParkingCommunityColumn ? 20 : 24">
    <el-alert
      v-if="contextReady && !hasCommunityContext"
      :title="emptyContextMessage"
      type="info"
      :closable="false"
      show-icon />
    <el-alert
      v-if="hasCommunityContext"
      title="保存成功仅表示数据已写入本系统；请以“停车平台已生效”为最终状态。失败任务会自动重试。"
      type="warning"
      :closable="false"
      show-icon />

    <el-card v-if="hasCommunityContext" class="content-card">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="内部免费车" name="internal">
          <div class="toolbar">
            <el-input
              v-model.trim="internalQuery.plateNumber"
              placeholder="完整7位或8位车牌号"
              clearable
              class="query-input" />
            <el-select
              v-model="internalQuery.syncState"
              placeholder="平台同步状态"
              clearable
              class="query-select">
              <el-option
                v-for="item in syncOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" />
            </el-select>
            <el-select
              v-model="internalQuery.localState"
              placeholder="本地状态"
              clearable
              class="query-select">
              <el-option label="本地有效" value="ACTIVE" />
              <el-option label="本地已失效" value="INACTIVE" />
            </el-select>
            <el-button type="primary" icon="el-icon-refresh" @click="loadInternalCars">刷新/查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetInternalQuery">重置</el-button>
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openInternalDialog()">新增内部车</el-button>
          </div>

          <el-table :data="internalCars" border v-loading="internalLoading">
            <el-table-column prop="plateNumber" label="车牌号" width="120" align="center" />
            <el-table-column label="人员" min-width="150">
              <template slot-scope="{ row }">
                <div>{{ row.personName }}</div>
                <div class="secondary">{{ row.personPhone || '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="3.5真实车辆类型" min-width="170">
              <template slot-scope="{ row }">
                {{ row.authTypeName }}（{{ row.authType }}）
              </template>
            </el-table-column>
            <el-table-column label="有效期" min-width="190" align="center">
              <template slot-scope="{ row }">
                {{ row.beginTime }}<br>至 {{ row.endTime }}
              </template>
            </el-table-column>
            <el-table-column label="本地状态" width="110" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="row.localState === 'ACTIVE' ? 'success' : 'info'">
                  {{ row.localState === 'ACTIVE' ? '本地有效' : '本地已失效' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="停车平台状态" min-width="165" align="center">
              <template slot-scope="{ row }">
                <el-tooltip
                  :disabled="!row.lastError"
                  :content="row.lastError || ''"
                  placement="top">
                  <el-tag :type="syncTagType(row.syncState)">
                    {{ syncStateText(row.syncState) }}
                  </el-tag>
                </el-tooltip>
                <div v-if="row.syncTime" class="secondary">{{ row.syncTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="operatorName" label="最后操作人" width="110" align="center" />
            <el-table-column label="操作" width="150" fixed="right" align="center">
              <template slot-scope="{ row }">
                <el-button
                  size="mini"
                  :disabled="row.localState !== 'ACTIVE' || row.syncState === 'WAITING_CHANGE'"
                  @click="openInternalDialog(row)">修改</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  :disabled="row.localState !== 'ACTIVE' || row.syncState === 'WAITING_CHANGE'"
                  @click="removeInternal(row)">失效</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            :current-page="internalPage.current"
            :page-size="internalPage.size"
            :page-sizes="[10, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="internalPage.total"
            @size-change="changeInternalSize"
            @current-change="changeInternalPage" />
        </el-tab-pane>

        <el-tab-pane label="黑名单车辆" name="blacklist">
          <div class="toolbar">
            <el-input
              v-model.trim="blackQuery.plateNumber"
              placeholder="完整7位或8位车牌号"
              clearable
              class="query-input" />
            <el-select
              v-model="blackQuery.syncState"
              placeholder="平台同步状态"
              clearable
              class="query-select">
              <el-option
                v-for="item in blacklistSyncOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" />
            </el-select>
            <el-select
              v-model="blackQuery.localState"
              placeholder="本地状态"
              clearable
              class="query-select">
              <el-option label="本地有效" value="ACTIVE" />
              <el-option label="本地已失效" value="INACTIVE" />
            </el-select>
            <el-button type="primary" icon="el-icon-refresh" @click="loadBlacklists">刷新/查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetBlackQuery">重置</el-button>
            <el-button
              type="danger"
              icon="el-icon-plus"
              @click="openBlacklistDialog()">新增黑名单</el-button>
          </div>

          <el-table :data="blacklists" border v-loading="blackLoading">
            <el-table-column prop="carNum" label="车牌号" width="120" align="center" />
            <el-table-column prop="remark" label="备注" min-width="180" />
            <el-table-column label="有效期" min-width="190" align="center">
              <template slot-scope="{ row }">
                {{ row.startTime }}<br>至 {{ row.endTime }}
              </template>
            </el-table-column>
            <el-table-column label="本地状态" width="110" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="row.localState === 'ACTIVE' ? 'danger' : 'info'">
                  {{ row.localState === 'ACTIVE' ? '本地有效' : '本地已失效' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="停车平台状态" min-width="165" align="center">
              <template slot-scope="{ row }">
                <el-tooltip
                  :disabled="!row.lastError"
                  :content="row.lastError || ''"
                  placement="top">
                  <el-tag :type="syncTagType(row.syncState)">
                    {{ syncStateText(row.syncState) }}
                  </el-tag>
                </el-tooltip>
                <div v-if="row.syncTime" class="secondary">{{ row.syncTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="operatorName" label="最后操作人" width="110" align="center" />
            <el-table-column label="操作" width="150" fixed="right" align="center">
              <template slot-scope="{ row }">
                <el-button
                  size="mini"
                  :disabled="row.localState !== 'ACTIVE'"
                  @click="openBlacklistDialog(row)">修改</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  :disabled="row.localState !== 'ACTIVE' || row.syncState === 'NOT_MANAGED'"
                  @click="removeBlacklist(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            :current-page="blackPage.current"
            :page-size="blackPage.size"
            :page-sizes="[10, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blackPage.total"
            @size-change="changeBlackSize"
            @current-change="changeBlackPage" />
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog
      :title="internalForm.internalCarId ? '修改内部免费车' : '新增内部免费车'"
      :visible.sync="internalVisible"
      width="620px"
      :close-on-click-modal="false">
      <el-alert
        title="车辆类型实时来自停车平台3.5；保存后由3.8同步，不会创建业主或车位。"
        type="info"
        :closable="false"
        class="dialog-alert" />
      <el-form ref="internalForm" :model="internalForm" :rules="internalRules" label-width="110px">
        <el-form-item label="车牌号" prop="plateNumber">
          <el-input v-model.trim="internalForm.plateNumber" maxlength="8" />
        </el-form-item>
        <el-form-item label="车主姓名" prop="personName">
          <el-input v-model.trim="internalForm.personName" maxlength="100" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model.trim="internalForm.personPhone" maxlength="30" />
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model.trim="internalForm.personAddress" maxlength="255" />
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="internalForm.personSex" clearable style="width:100%">
            <el-option label="男" :value="0" />
            <el-option label="女" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="车辆类型" prop="authType">
          <el-select
            v-model="internalForm.authType"
            filterable
            style="width:100%"
            placeholder="请选择停车平台3.5返回的内部/免费类型">
            <el-option
              v-for="item in authTypes"
              :key="item.authType"
              :label="`${item.authTypeName}（${item.authType}）`"
              :value="item.authType" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="beginTime">
          <el-date-picker
            v-model="internalForm.beginTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="internalForm.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="internalVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitInternal">保存到本地并同步</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="blackForm.bwId ? '修改黑名单' : '新增黑名单'"
      :visible.sync="blackVisible"
      width="600px"
      :close-on-click-modal="false">
      <el-form ref="blackForm" :model="blackForm" :rules="blackRules" label-width="100px">
        <el-form-item label="车牌号" prop="plateNumber">
          <el-input v-model.trim="blackForm.plateNumber" maxlength="8" />
        </el-form-item>
        <el-form-item label="开始时间" prop="beginTime">
          <el-date-picker
            v-model="blackForm.beginTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="blackForm.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="blackForm.remark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="blackVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitBlacklist">保存到本地并同步</el-button>
      </span>
    </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  listInternalCars,
  saveInternalCar,
  updateInternalCar,
  deleteInternalCar,
  listBlacklists,
  saveBlacklist,
  updateBlacklist,
  deleteBlacklist
} from '@/api/car/parking99PhaseFiveApi'
import { listParking99MonthAuthTypes } from '@/api/fee/buyCarMonthCardApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getStoreInfo } from '@/api/user/indexApi'
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'
import { listParking99Channels } from '@/api/car/parking99GateControlApi'

const platePattern = /^[\u4e00-\u9fa5][A-Z][A-Z0-9]{5,6}$/

export default {
  name: 'CarBlackWhiteManage',
  components: {
    SelectAdminCommunity
  },
  data() {
    const validatePlate = (rule, value, callback) => {
      const plate = (value || '').trim().toUpperCase()
      if (!platePattern.test(plate)) {
        callback(new Error('请输入完整的7位或8位车牌号'))
        return
      }
      callback()
    }
    const validateEnd = (rule, value, callback) => {
      const form = rule.field === 'endTime' && this.internalVisible
        ? this.internalForm : this.blackForm
      if (!value || !form.beginTime || new Date(value) <= new Date(form.beginTime)) {
        callback(new Error('结束时间必须晚于开始时间'))
        return
      }
      callback()
    }
    return {
      activeTab: 'internal',
      communityId: '',
      contextReady: false,
      showCommunitySelector: false,
      parkingCommunities: [],
      internalLoading: false,
      blackLoading: false,
      saving: false,
      internalCars: [],
      blacklists: [],
      authTypes: [],
      internalQuery: { plateNumber: '', localState: '', syncState: '' },
      blackQuery: { plateNumber: '', localState: '', syncState: '' },
      internalPage: { current: 1, size: 10, total: 0 },
      blackPage: { current: 1, size: 10, total: 0 },
      internalVisible: false,
      blackVisible: false,
      internalForm: this.newInternalForm(),
      blackForm: this.newBlackForm(),
      syncOptions: [
        { value: 'PENDING', label: '本地已保存/待同步' },
        { value: 'RETRY', label: '同步失败/自动重试' },
        { value: 'WAITING_CHANGE', label: '平台已接收/待确认' },
        { value: 'COMPLETED', label: '停车平台已生效' }
      ],
      blacklistSyncOptions: [
        { value: 'NOT_MANAGED', label: '旧数据/未纳入同步' },
        { value: 'PENDING', label: '本地已保存/待同步' },
        { value: 'RETRY', label: '同步失败/自动重试' },
        { value: 'COMPLETED', label: '停车平台已生效' }
      ],
      internalRules: {
        plateNumber: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          { validator: validatePlate, trigger: 'blur' }
        ],
        personName: [{ required: true, message: '请输入车主姓名', trigger: 'blur' }],
        authType: [{ required: true, message: '请选择3.5真实车辆类型', trigger: 'change' }],
        beginTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          { validator: validateEnd, trigger: 'change' }
        ]
      },
      blackRules: {
        plateNumber: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          { validator: validatePlate, trigger: 'blur' }
        ],
        beginTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          { validator: validateEnd, trigger: 'change' }
        ],
        remark: [{ required: true, message: '请输入黑名单备注', trigger: 'blur' }]
      }
    }
  },
  computed: {
    hasCommunityContext() {
      return Boolean(this.communityId && this.communityId !== '-1')
    },
    showParkingCommunityColumn() {
      return this.showCommunitySelector && this.parkingCommunities.length > 0
    },
    emptyContextMessage() {
      if (!this.parkingCommunities.length) {
        return '当前账号没有可访问且已启用的停车配置'
      }
      return this.showCommunitySelector
        ? '请先在左侧选择已接入停车平台的小区'
        : '当前小区尚未接入或未启用停车配置'
    }
  },
  created() {
    this.initializeCommunityContext()
  },
  methods: {
    async initializeCommunityContext() {
      try {
        const store = await getStoreInfo()
        this.showCommunitySelector = [
          '800900000000',
          '800900000001'
        ].includes(store.storeTypeCd)
        await this.loadParkingCommunities()
        if (!this.showCommunitySelector) {
          const currentCommunityId = getCommunityId()
          this.communityId = this.parkingCommunities.some(
            item => item.communityId === currentCommunityId
          ) ? currentCommunityId : ''
        }
      } catch (error) {
        this.$message.error(error.message || '当前商户信息加载失败')
      } finally {
        this.contextReady = true
      }
      if (this.hasCommunityContext) {
        this.loadInternalCars()
      }
    },
    async loadParkingCommunities() {
      const result = await listParking99Channels()
      const communities = []
      const seen = new Set()
      const configs = result.data || []
      configs.forEach(config => {
        if (config.enabled !== 'Y' || seen.has(config.communityId)) {
          return
        }
        seen.add(config.communityId)
        communities.push({
          communityId: config.communityId,
          name: config.communityName || config.communityId
        })
      })
      this.parkingCommunities = communities
    },
    handleChangeCommunity(community) {
      this.communityId = community && community.communityId
        ? community.communityId : ''
      this.internalCars = []
      this.blacklists = []
      this.authTypes = []
      this.internalVisible = false
      this.blackVisible = false
      this.internalPage.current = 1
      this.internalPage.total = 0
      this.blackPage.current = 1
      this.blackPage.total = 0
      if (this.hasCommunityContext) {
        this.handleTabChange()
      }
    },
    newInternalForm() {
      const range = this.defaultRange()
      return {
        internalCarId: '',
        plateNumber: '',
        personName: '',
        personPhone: '',
        personAddress: '',
        personSex: null,
        authType: null,
        beginTime: range.begin,
        endTime: range.end
      }
    },
    newBlackForm() {
      const range = this.defaultRange()
      return {
        bwId: '',
        plateNumber: '',
        beginTime: range.begin,
        endTime: range.end,
        remark: ''
      }
    },
    defaultRange() {
      const begin = new Date()
      const end = new Date(begin)
      end.setFullYear(end.getFullYear() + 1)
      return { begin: this.formatDate(begin), end: this.formatDate(end) }
    },
    formatDate(value) {
      const pad = number => String(number).padStart(2, '0')
      return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`
    },
    handleTabChange() {
      if (this.activeTab === 'internal') {
        this.loadInternalCars()
      } else {
        this.loadBlacklists()
      }
    },
    async loadInternalCars() {
      this.internalLoading = true
      try {
        const result = await listInternalCars({
          communityId: this.communityId,
          ...this.internalQuery,
          page: this.internalPage.current,
          row: this.internalPage.size
        })
        this.internalCars = result.data || []
        this.internalPage.total = result.total || 0
      } catch (error) {
        this.$message.error(error.message || '内部车查询失败')
      } finally {
        this.internalLoading = false
      }
    },
    async loadBlacklists() {
      this.blackLoading = true
      try {
        const result = await listBlacklists({
          communityId: this.communityId,
          ...this.blackQuery,
          page: this.blackPage.current,
          row: this.blackPage.size
        })
        this.blacklists = result.data || []
        this.blackPage.total = result.total || 0
      } catch (error) {
        this.$message.error(error.message || '黑名单查询失败')
      } finally {
        this.blackLoading = false
      }
    },
    resetInternalQuery() {
      this.internalQuery = { plateNumber: '', localState: '', syncState: '' }
      this.internalPage.current = 1
      this.loadInternalCars()
    },
    resetBlackQuery() {
      this.blackQuery = { plateNumber: '', localState: '', syncState: '' }
      this.blackPage.current = 1
      this.loadBlacklists()
    },
    changeInternalSize(size) {
      this.internalPage.size = size
      this.internalPage.current = 1
      this.loadInternalCars()
    },
    changeInternalPage(page) {
      this.internalPage.current = page
      this.loadInternalCars()
    },
    changeBlackSize(size) {
      this.blackPage.size = size
      this.blackPage.current = 1
      this.loadBlacklists()
    },
    changeBlackPage(page) {
      this.blackPage.current = page
      this.loadBlacklists()
    },
    async openInternalDialog(row) {
      try {
        const result = await listParking99MonthAuthTypes({
          communityId: this.communityId
        })
        this.authTypes = (result.data || []).filter(item => Number(item.authType) > 0)
        if (!this.authTypes.length) {
          throw new Error('停车平台3.5未返回可选车辆类型')
        }
        this.internalForm = row ? {
          internalCarId: row.internalCarId,
          plateNumber: row.plateNumber,
          personName: row.personName,
          personPhone: row.personPhone || '',
          personAddress: row.personAddress || '',
          personSex: row.personSex,
          authType: row.authType,
          beginTime: row.beginTime,
          endTime: row.endTime
        } : this.newInternalForm()
        this.internalVisible = true
        this.$nextTick(() => this.$refs.internalForm && this.$refs.internalForm.clearValidate())
      } catch (error) {
        this.$message.error(error.message || '车辆类型查询失败')
      }
    },
    submitInternal() {
      this.$refs.internalForm.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const data = {
            ...this.internalForm,
            plateNumber: this.internalForm.plateNumber.toUpperCase(),
            communityId: this.communityId
          }
          if (data.internalCarId) {
            await updateInternalCar(data)
          } else {
            delete data.internalCarId
            await saveInternalCar(data)
          }
          this.$message.success('本地已保存；停车平台尚待同步确认')
          this.internalVisible = false
          this.loadInternalCars()
        } catch (error) {
          this.$message.error(error.message || '内部车保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    removeInternal(row) {
      this.$confirm(
        `确认将 ${row.plateNumber} 在本地标记失效并排队同步停车平台？`,
        '失效内部车',
        { type: 'warning' }
      ).then(async () => {
        try {
          await deleteInternalCar({
            communityId: this.communityId,
            internalCarId: row.internalCarId
          })
          this.$message.success('本地已标记失效；停车平台删除尚待确认')
          this.loadInternalCars()
        } catch (error) {
          this.$message.error(error.message || '内部车失效失败')
        }
      }).catch(() => {})
    },
    openBlacklistDialog(row) {
      this.blackForm = row ? {
        bwId: row.bwId,
        plateNumber: row.carNum,
        beginTime: row.startTime,
        endTime: row.endTime,
        remark: row.remark || ''
      } : this.newBlackForm()
      this.blackVisible = true
      this.$nextTick(() => this.$refs.blackForm && this.$refs.blackForm.clearValidate())
    },
    submitBlacklist() {
      this.$refs.blackForm.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const data = {
            ...this.blackForm,
            plateNumber: this.blackForm.plateNumber.toUpperCase(),
            communityId: this.communityId
          }
          if (data.bwId) {
            await updateBlacklist(data)
          } else {
            delete data.bwId
            await saveBlacklist(data)
          }
          this.$message.success('本地已保存；停车平台尚待同步')
          this.blackVisible = false
          this.loadBlacklists()
        } catch (error) {
          this.$message.error(error.message || '黑名单保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    removeBlacklist(row) {
      this.$confirm(
        `确认删除 ${row.carNum} 的黑名单权限并同步停车平台？`,
        '删除黑名单',
        { type: 'warning' }
      ).then(async () => {
        try {
          await deleteBlacklist({
            communityId: this.communityId,
            bwId: row.bwId
          })
          this.$message.success('本地已标记删除；停车平台尚待同步')
          this.loadBlacklists()
        } catch (error) {
          this.$message.error(error.message || '黑名单删除失败')
        }
      }).catch(() => {})
    },
    syncStateText(state) {
      const labels = {
        NOT_MANAGED: '旧数据/未纳入同步',
        PENDING: '本地已保存/待同步',
        RETRY: '同步失败/自动重试',
        WAITING_CHANGE: '平台已接收/待确认',
        COMPLETED: '停车平台已生效'
      }
      return labels[state] || state || '未知'
    },
    syncTagType(state) {
      if (state === 'COMPLETED') return 'success'
      if (state === 'RETRY') return 'danger'
      if (state === 'PENDING' || state === 'WAITING_CHANGE') return 'warning'
      return 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.parking99-phase-five {
  padding: 20px;
}

.content-card {
  margin-top: 16px;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.query-input {
  width: 210px;
}

.query-select {
  width: 190px;
}

.pagination {
  margin-top: 18px;
  text-align: right;
}

.secondary {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.dialog-alert {
  margin-bottom: 16px;
}
</style>
